<!--
  Same layout as voyage-credit-info.component.html — see that component's
  header for why this is a literal copy rather than a shared template. No
  `showTargets` binding: this catalogue carries no `target` field at all.
-->
<div class="vci">
  <div class="vci__head">
    <h4 class="vci__title">How credits work</h4>
    <button class="vci__x" type="button" aria-label="Close" (click)="onClose()">
      <mat-icon class="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <div class="vci__body" id="scrollcustom">
    <div class="vci__body-inner">
      <p class="vci__lede">
        {{ sensorName }} is priced in credits rather than by area or scene. You buy credits when you
        task the sensor, then spend them on the actions below — one at a time, as you need them,
        any time while your time of interest (TOI) is open.
      </p>

      <section class="vci__card">
        <h5 class="vci__card-title">What a credit buys</h5>

        <div class="vci__rate" *ngIf="showPricing">
          <span class="vci__rate-eq">
            <b>1 credit</b>
            <i>=</i>
            <b class="vci__rate-price">{{ costLabel(unitPrice) }}</b>
          </span>
          <span class="vci__rate-note">Each action below costs a fixed number of credits.</span>
        </div>

        <app-voyage-credit-catalogue
          [actions]="actions"
          [unitPrice]="unitPrice"
          [showPricing]="showPricing"
        ></app-voyage-credit-catalogue>
      </section>

      <section class="vci__card">
        <h5 class="vci__card-title">Buying and spending</h5>

        <ul class="vci__facts">
          <li>
            <mat-icon class="material-icons-outlined">shopping_cart</mat-icon>
            <span>
              Credits are bought per task, as part of tasking this sensor. {{ boundsLabel }}
            </span>
          </li>
          <li>
            <mat-icon class="material-icons-outlined">travel_explore</mat-icon>
            <span>
              They are spent from this sensor's panel on the collection map, an action at a time.
              Nothing is charged until you take one.
            </span>
          </li>
          <li>
            <mat-icon class="material-icons-outlined">schedule</mat-icon>
            <span>Credits stay spendable for as long as the task's TOI is open.</span>
          </li>
          <li>
            <mat-icon class="material-icons-outlined">undo</mat-icon>
            <span>Unused credits can be refunded on request, subject to approval.</span>
          </li>
        </ul>
      </section>
    </div>
  </div>
</div>
